import { render, staticRenderFns } from "./FluidFormItem.vue?vue&type=template&id=9b39f716&scoped=true"
import script from "./FluidFormItem.vue?vue&type=script&lang=js"
export * from "./FluidFormItem.vue?vue&type=script&lang=js"
import style0 from "./FluidFormItem.vue?vue&type=style&index=0&id=9b39f716&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b39f716",
  null
  
)

export default component.exports